<template>
  <div
      class="row row-cols-auto"
      :class="{ 'secondary-style': props.secondaryStyle }"
  >
    <MonthSwitch
      v-if="props.dateSelectType === dateSelectTypes.dateRangeWithMonthSwitch"
    />
    <AllOfficeInput />
    <DateSingleInput
      v-if="props.dateSelectType === dateSelectTypes.dateSingle"
      :hideTime="props.hideTime"
    />
    <DateRangeInput
      v-if="[
          dateSelectTypes.dateRange,
          dateSelectTypes.dateRangeWithMonthSwitch,
      ].includes(props.dateSelectType)"
      :hideTime="props.hideTime"
      :showMinute="props.showMinute"
    />
    <CarNumInput
        v-if="props.hideCarNum !== true"
    />
    <CarDriverInput
        v-if="props.hideCarDriver !== true"
    />
    <PayTypeInput
        v-if="props.showPayType"
    />

    <div class="col d-flex align-items-end search-actions">
      <button class="btn btn-primary shadow-sm refresh-btn" @click="onResetForm" type="button">
        <BIconArrowCounterclockwise/>
      </button>
      <button class="btn btn-primary shadow-sm search-btn" @click="onSubmit" type="button">
        <BIconSearch/>&nbsp;조회
      </button>
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {BIconArrowCounterclockwise, BIconSearch} from "bootstrap-icons-vue";
import DateRangeInput from "@/components/tacho/searchbar/DateRangeInput.vue";
import CarNumInput from "@/components/tacho/searchbar/CarNumInput.vue";
import CarDriverInput from "@/components/tacho/searchbar/CarDriverInput.vue";
import DateSingleInput from "@/components/tacho/searchbar/DateSingleInput.vue";
import {dateSelectTypes, processSubmits} from "@/components/tacho/searchbar/search-utils";
import MonthSwitch from "@/components/tacho/searchbar/MonthSwitch.vue";
import PayTypeInput from "@/components/tacho/searchbar/PayTypeInput.vue";
import AllOfficeInput from "@/components/tacho/searchbar/AllOfficeInput.vue";

const store = useStore();
const initSearchBar = (data) => store.dispatch('initSearchBar', data);
const resetSearchBar = () => store.dispatch('resetSearchBar');
const searchBar = computed(() => store.state.searchBar);
const emit = defineEmits([]);
const props = defineProps({
  dateSelectType: {
    type: String,
    default: dateSelectTypes.dateRange,
    validator: (value) => Object.values(dateSelectTypes).includes(value),
  },
  showMinute: Boolean,
  hideTime: Boolean,
  strictHourByOffice: Boolean,
  syncTime: Boolean,
  autoSelectDriver: Boolean,
  showPayType: Boolean,
  hideCarNum: Boolean,
  hideCarDriver: Boolean,
  secondaryStyle: Boolean,
  onSubmitTripQuery: Function,
  onSubmitDriverShiftQuery: Function,
  onSubmitOfficeShiftQuery: Function,
  searchRef: Object,
});
defineExpose({
  submit: onSubmit,
});

function onResetForm() {
  resetSearchBar();
}

function hasSubmitProp() {
  return Object.keys(props).find((key) => {
    return key.startsWith('onSubmit') && typeof props[key] === 'function';
  });
}

function onSubmit() {
  if (!hasSubmitProp()) {
    store.commit('updateDateRangeGroup');
    return;
  }

  processSubmits(store, props, searchBar.value);
}

async function loadInitialData() {
  await initSearchBar({
    autoSelectDriver: props.autoSelectDriver,
    showPayType: props.showPayType,
    secondaryStyle: props.secondaryStyle,
    strictHourByOffice: props.strictHourByOffice,
    syncTime: props.syncTime,
  });
  onSubmit();
}

onMounted(loadInitialData)

</script>

<style>
.p-autocomplete-panel {
  transition: opacity 0.3s;
  border: 1px solid #d5d5d5 !important;
}

.p-autocomplete-panel.p-connected-overlay-enter-active {
  opacity: 0;
}

.p-autocomplete-panel .p-autocomplete-items {
  padding: 0;
  margin: 0;
}

.p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item {
  padding: 0.4rem 0.65rem !important;
  font-size: 0.85rem !important;
}

.secondary-style > .col {
  width: 50%;
}

.secondary-style > .col:nth-child(1) {
  width: 100%;
}

.secondary-style > .col:nth-child(n+3) {
  margin-top: 10px;
}

.secondary-style .p-autocomplete .p-autocomplete-input {
  width: 100%;
  font-size: .8rem !important;
}

.secondary-style .p-autocomplete .p-button {
  height: 29px;
}

.secondary-style .search-date {
  padding: 4px 8px;
  font-size: .8rem;
}

.secondary-style .search-time-col {
  margin-left: 0 !important;
  padding: 0 calc(var(--bs-gutter-x) * .5) 0 0;
  flex: 0.5;
}

.secondary-style .search-actions {
  width: 100%;
}

.secondary-style .search-actions .btn {
  font-size: .8rem;
}

.secondary-style .search-actions .search-btn {
  width: 100%;
}
</style>
